import { createFileRoute } from "@tanstack/react-router";
import DemoRequestPage from "@/pages/demo-request/DemoRequestPage";

export const Route = createFileRoute("/demo-request")({
  component: DemoRequestPage,
});
